"use client";
import {
  ChartConfig,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { Item, ItemTitle } from "@/components/ui/item";
import { UI } from "@/constants";
import { getWeekNumber, numberUsLocale } from "@/lib";
import { WeekGroup } from "@/types";
import { CartesianGrid, Line, LineChart, XAxis, YAxis } from "recharts";

const chartConfig = {
  productsRemoved: {
    label: UI.labels.productsRemoved,
    color: "var(--destructive)",
  },
  productsAdded: {
    label: UI.labels.productsAdded,
    color: "var(--success)",
  },
} satisfies ChartConfig;

type ProductTrendsChartProps = {
  orders: WeekGroup[];
};

export const ProductTrendsChart = ({ orders }: ProductTrendsChartProps) => {
  if (!orders?.length) return null;
  const data = orders.map(o => ({
    ...o,
    weekLabel: `${getWeekNumber(o.weekNumber)} ${UI.labels.week}`,
  }));

  return (
    <Item variant="outline">
      <ItemTitle>{UI.titles.productPerformanceTrends}</ItemTitle>
      <ChartContainer config={chartConfig} className="chart-container">
        <LineChart accessibilityLayer data={data}>
          <CartesianGrid vertical={false} />
          <YAxis
            type="number"
            tickMargin={8}
            padding={{ bottom: 16 }}
            tickFormatter={(volume: number) => numberUsLocale(volume)}
          />
          <XAxis
            dataKey="weekLabel"
            tickMargin={8}
            minTickGap={16}
            padding={{ left: 16, right: 16 }}
          />
          <ChartTooltip content={<ChartTooltipContent className="w-52" />} />
          <ChartLegend content={<ChartLegendContent />} />
          <Line
            dataKey="productsRemoved"
            type="linear"
            stroke="var(--color-productsRemoved)"
            strokeWidth={2}
            activeDot={{ r: 4 }}
          />
          <Line
            dataKey="productsAdded"
            type="linear"
            stroke="var(--color-productsAdded)"
            strokeWidth={2}
            activeDot={{ r: 4 }}
          />
        </LineChart>
      </ChartContainer>
    </Item>
  );
};
